export const LOADING_START_EVENT = "editor-event/loading/start";
export const LOADING_END_EVENT = "editor-event/loading/end";

export const ERROR_EVENT = "editor-event/error"
